import { AccessLinkWhereInput } from '@/@generated/codegen/API';
import { useQueryParams } from '@/hooks/useQueryParams';
import { useOrderByQueryParam } from '@/utils/query-params/useOrderByQueryParam';
import { usePaginationQueryParam } from '@/utils/query-params/usePaginationQueryParam';

export const useAccessLinksListQueryParams = (
  pageSize: number,
  where: AccessLinkWhereInput,
  prefix: string | null
) => {
  const queryObject = useQueryParams([], prefix);

  const orderByArgs = useOrderByQueryParam(prefix);
  const paginationArgs = usePaginationQueryParam(pageSize, prefix);

  const final_where: AccessLinkWhereInput = {
    AND: [where],
  };

  return {
    paginationArgs,
    orderByArgs,
    where: final_where,
  };
};
